import { put, takeEvery, call } from '@redux-saga/core/effects';
import {
  get_sellers_success,
  get_sellers_error,
  get_sellers,
  get_products,
  get_product,
  get_products_success,
  get_product_success,
  get_product_error,
  get_products_error,
  add_product_basket_error,
  add_product_basket_success,
  add_product_basket,
  get_sellers_locations,
  get_sellers_locations_error,
  get_sellers_locations_success,
} from './reducer';
import api from '@service/DataService';
import toast from 'react-hot-toast';

function* getSellersSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/partners/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_sellers_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_sellers_error.type,
    });
  }
}
function* getSellersDeliveryLocationSaga({ payload }) {
  try {
    const requestRes = yield call(
      api.get,
      `/delivery_locations/bypartner/${payload}`,
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_sellers_locations_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: get_sellers_locations_error.type,
    });
  }
}

function* getSellersProductsSaga({ payload }) {
  try {
    const { id, filter } = payload;
    let category = ``;

    if (filter) {
      category = `&product_category=${filter}`;
    }

    const requestRes = yield call(
      api.get,
      `/products/bypartner/${id}?&page=1&limit=20${category}`,
    );

    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_products_success.type,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: get_products_error.type,
    });
  }
}

function* getProductSaga({ payload }) {
  try {
    const requestRes = yield call(api.get, `/products/${payload}`);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_product_success.type,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: get_product_error.type,
    });
  }
}

function* addProductBasket({ payload }) {
  try {
    const requestRes = yield call(api.post, '/basket_products', payload);
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: add_product_basket_success.type,
      payload: response,
    });
  } catch (error) {
    toast.error(error.response.data.message);
    yield put({
      type: add_product_basket_error.type,
    });
  }
}
function* productSagas() {
  yield takeEvery(get_sellers.type, getSellersSaga);
  yield takeEvery(add_product_basket.type, addProductBasket);
  yield takeEvery(get_product.type, getProductSaga);
  yield takeEvery(get_products.type, getSellersProductsSaga);
  yield takeEvery(get_sellers_locations.type, getSellersDeliveryLocationSaga);
}

export default productSagas;
